/* =============================================================================
   MYTHIC — app.js
   Single script for the whole theme. No section carries its own cart or search
   logic, so nothing can double-bind and nothing double-adds to the cart.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return '$' + (Number(c || 0) / 100).toFixed(2); };

  /* ---------------------------------------------------------------- Toast */
  var tray;
  function toast(o) {
    if (!tray) { tray = document.createElement('div'); tray.className = 'toasts'; document.body.appendChild(tray); }
    var t = document.createElement('div');
    t.className = 'toast' + (o.bad ? ' toast--bad' : '');
    t.innerHTML =
      (o.img ? '<img src="' + o.img + '" alt="">' : '') +
      '<div class="toast__t"><b>' + (o.title || '') + '</b>' + (o.sub ? '<span>' + o.sub + '</span>' : '') + '</div>' +
      (o.bad ? '' : '<a href="/cart">Cart</a>');
    tray.appendChild(t);
    setTimeout(function () {
      t.classList.add('out');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 220);
    }, o.bad ? 4200 : 3000);
  }

  /* ----------------------------------------------------------------- Cart */
  var Cart = {
    add: function (id, qty, props) {
      var b = { id: Number(id), quantity: qty || 1 };
      if (props) b.properties = props;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(b)
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
          return d;
        });
      });
    },
    change: function (line, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function (r) { return r.json(); });
    },
    get: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },
    sync: function () {
      return Cart.get().then(function (c) {
        $$('[data-cart-pip]').forEach(function (el) {
          el.textContent = c.item_count;
          el.style.display = c.item_count > 0 ? '' : 'none';
        });
        document.dispatchEvent(new CustomEvent('mythic:cart', { detail: c }));
        return c;
      });
    }
  };

  /* ------------------------------------------------------------- Quick add */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b || b.disabled) return;
    e.preventDefault(); e.stopPropagation();

    var id = b.getAttribute('data-variant');
    if (!id) return;
    var html = b.innerHTML;
    b.disabled = true;
    b.innerHTML = '<span>·</span>';

    Cart.add(id, 1).then(function (item) {
      b.classList.add('done');
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
      toast({ title: 'Added to cart', sub: item.product_title || b.getAttribute('data-title') || '', img: b.getAttribute('data-img') });
      return Cart.sync();
    }).catch(function (err) {
      toast({ title: "Couldn't add that", sub: err.message, bad: true });
    }).then(function () {
      setTimeout(function () { b.disabled = false; b.classList.remove('done'); b.innerHTML = html; }, 1400);
    });
  });

  /* --------------------------------------------- Card variant → price sync */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-cardsel]');
    if (!s) return;
    var card = s.closest('.card'); if (!card) return;
    var o = s.options[s.selectedIndex];
    var p = $('[data-cardprice]', card);
    var b = $('[data-add]', card);
    if (p && o.dataset.price) p.textContent = money(o.dataset.price);
    if (b) { b.setAttribute('data-variant', o.value); b.disabled = o.dataset.avail === 'false'; }
  });

  /* -------------------------------------------------------- Load more page */
  function pull(btn) {
    var next = btn.getAttribute('data-next');
    var grid = $('[data-grid]');
    if (!next || !grid) return Promise.resolve(false);

    btn.disabled = true;
    return fetch(next, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inc = doc.querySelector('[data-grid]');
        var nb  = doc.querySelector('[data-more]');
        var added = 0;
        if (inc) {
          Array.prototype.slice.call(inc.children).forEach(function (n) {
            grid.appendChild(document.importNode(n, true)); added++;
          });
        }
        if (nb && nb.getAttribute('data-next')) {
          btn.setAttribute('data-next', nb.getAttribute('data-next'));
          btn.disabled = false;
        } else {
          btn.removeAttribute('data-next');
        }
        var c = $('[data-count]');
        if (c) c.textContent = grid.children.length + ' of ' + (c.getAttribute('data-total') || '') + ' designs';
        paintHearts();
        try { history.replaceState(null, '', next); } catch (err) {}
        return added > 0 && btn.hasAttribute('data-next');
      })
      .catch(function () { btn.disabled = false; return false; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-more]');
    if (b && !b.disabled) { e.preventDefault(); pull(b); }
  });

  /* --------------------------------------------------- Endless scroll feed */
  function endless() {
    var sent = $('[data-sentinel]');
    var btn  = $('[data-more]');
    if (!sent || !btn || !('IntersectionObserver' in window)) return;

    var spin = $('[data-spin]');
    var busy = false;

    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting || busy) return;
      if (!btn.hasAttribute('data-next')) { io.disconnect(); done(); return; }

      busy = true;
      if (spin) spin.classList.add('on');

      pull(btn).then(function (more) {
        busy = false;
        if (spin) spin.classList.remove('on');
        if (!more) { io.disconnect(); done(); }
      });
    }, { rootMargin: '1000px 0px' });

    io.observe(sent);
    btn.style.display = 'none';

    function done() {
      if (spin) spin.classList.remove('on');
      var c = $('[data-endcap]');
      if (c) c.style.display = 'block';
    }
  }

  /* ------------------------------------------------------------- Favourites */
  var KEY = 'mythic_wishlist';
  function favs() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function paintHearts() {
    var ids = favs().map(function (f) { return String(f && f.id ? f.id : f); });
    $$('[data-fav]').forEach(function (b) {
      var on = ids.indexOf(b.getAttribute('data-pid')) > -1;
      b.textContent = on ? '\u2764\uFE0F' : '\uD83E\uDD0D';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-fav-pip]').forEach(function (el) {
      el.textContent = ids.length;
      el.style.display = ids.length > 0 ? '' : 'none';
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();

    var id = b.getAttribute('data-pid');
    var list = favs();
    var i = -1;
    list.forEach(function (f, n) { if (String(f && f.id ? f.id : f) === id) i = n; });

    if (i > -1) list.splice(i, 1);
    else list.push({
      id: id,
      title: b.getAttribute('data-title') || '',
      url: b.getAttribute('data-url') || '',
      image: b.getAttribute('data-img') || '',
      price: b.getAttribute('data-price') || ''
    });

    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (err) {}
    paintHearts();
  });

  /* ------------------------------------------------------------ Nav drawer */
  function drawer() {
    var d = $('[data-drawer]'), s = $('[data-scrim]');
    if (!d || !s) return;
    function set(on) {
      d.classList.toggle('on', on);
      s.classList.toggle('on', on);
      document.body.style.overflow = on ? 'hidden' : '';
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) { set(true); return; }
      if (e.target.closest('[data-menu-close]') || e.target.closest('[data-scrim]')) set(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ----------------------------------------------------- Search (one only) */
  function search() {
    var root = $('[data-seek]');
    if (!root) return;

    var input = $('[data-seek-in]', root);
    var hits  = $('[data-seek-hits]', root);
    var pane  = $('[data-seek-res]', root);
    var idle  = $('[data-seek-idle]', root);
    var none  = $('[data-seek-none]', root);
    var all   = $('[data-seek-all]', root);
    var t, seq = 0;

    function open() { root.classList.add('on'); document.body.style.overflow = 'hidden'; setTimeout(function () { input.focus(); }, 60); }
    function close() { root.classList.remove('on'); document.body.style.overflow = ''; }
    function view(v) { pane.hidden = v !== 'res'; idle.hidden = v !== 'idle'; none.hidden = v !== 'none'; }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-seek-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-seek-close]')) close();
      var term = e.target.closest('[data-term]');
      if (term && root.contains(term)) { input.value = term.getAttribute('data-term'); go(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('on')) close(); });

    function go() {
      var q = (input.value || '').trim();
      if (q.length < 2) { view('idle'); return; }
      var mine = ++seq;

      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last',
            { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (mine !== seq) return; // a newer keystroke already landed
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (!ps.length) { view('none'); return; }
          hits.innerHTML = ps.map(function (p) {
            var im = p.featured_image && p.featured_image.url
              ? '<img src="' + p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="">' : '';
            return '<a class="hit" href="' + p.url + '">' + im +
              '<span><span class="hit__n">' + p.title + '</span>' +
              '<span class="hit__p">' + (p.price ? money(p.price) : '') + '</span></span></a>';
          }).join('');
          all.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
          all.textContent = 'See all results for "' + q + '"';
          view('res');
        })
        .catch(function () { view('idle'); });
    }

    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(go, 200); });
    window.MythicSearch = { open: open, close: close };
  }

  /* -------------------------------------------------------- Product page */
  function product() {
    var root = $('[data-pdp]');
    if (!root) return;

    var data = $('[data-variants]', root);
    if (!data) return;
    var variants = JSON.parse(data.textContent || '[]');
    var main = $('[data-pdp-img]', root);
    var priceEl = $('[data-pdp-price]', root);
    var wasEl = $('[data-pdp-was]', root);
    var idEl = $('[data-pdp-id]', root);
    var addEl = $('[data-pdp-add]', root);
    var bar = $('[data-buybar]');

    function pick() {
      var chosen = $$('[data-opt].on', root).map(function (b) { return b.getAttribute('data-val'); });
      var v = variants.filter(function (x) {
        return x.options.length === chosen.length && x.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      if (!v) return;

      if (idEl) idEl.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (wasEl) {
        wasEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        wasEl.style.display = v.compare_at_price > v.price ? '' : 'none';
      }
      if (addEl) {
        addEl.disabled = !v.available;
        addEl.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (bar) {
        var bp = $('[data-buybar-price]', bar);
        if (bp) bp.textContent = money(v.price);
      }
      if (v.image && main) main.src = v.image;
      try { history.replaceState({}, '', '?variant=' + v.id); } catch (e) {}
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-opt]');
      if (!b) return;
      $$('[data-opt][data-name="' + b.getAttribute('data-name') + '"]', root).forEach(function (x) { x.classList.remove('on'); });
      b.classList.add('on');
      pick();
    });

    $$('[data-pdp-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) main.src = t.getAttribute('data-full');
        $$('[data-pdp-thumb]', root).forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
      });
    });

    var q = $('[data-qty]', root);
    if (q) {
      root.addEventListener('click', function (e) {
        var s = e.target.closest('[data-qstep]');
        if (!s) return;
        var n = parseInt(q.value, 10) || 1;
        q.value = Math.max(1, n + parseInt(s.getAttribute('data-qstep'), 10));
      });
    }

    if (bar) {
      var anchor = $('[data-buyanchor]', root);
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          bar.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }, { threshold: 0 }).observe(anchor);
      }
      bar.addEventListener('click', function (e) {
        if (!e.target.closest('[data-buybar-add]')) return;
        var f = $('[data-pdp-form]');
        if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
      });
    }
  }

  /* ------------------------------------------------------------ Cart page */
  function cartPage() {
    var root = $('[data-cartpage]');
    if (!root) return;

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        e.preventDefault();
        Cart.change(Number(rm.getAttribute('data-remove')), 0).then(function () { location.reload(); });
        return;
      }
      var st = e.target.closest('[data-linestep]');
      if (st) {
        var line = Number(st.getAttribute('data-line'));
        var input = $('[data-lineqty][data-line="' + line + '"]', root);
        var n = Math.max(0, (parseInt(input.value, 10) || 1) + parseInt(st.getAttribute('data-linestep'), 10));
        Cart.change(line, n).then(function () { location.reload(); });
      }
    });
  }

  /* ---------------------------------------------------------------- Boot */
  function boot() {
    paintHearts(); drawer(); search(); endless(); product(); cartPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.Mythic = { cart: Cart, toast: toast, money: money };
})();
